/**
 * This file defines the common functionality for each product's campaign module
 */
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { CampaignModuleEditConfiguration } from 'models/interfaces';
import PvsCampaignEditConfiguration from '../PvsCampaigns/PvsCampaignEditConfiguration';
import P3CampaignEditConfiguration from '../P3Campaigns/P3CampaignEditConfiguration';

/**
 * Returns default values foreach of the common functionality required by
 * CampaignModuleEditConfiguration. As there is no default campaign module,
 * these functions should not actually work.
 */
function getDefaultCampaignConfiguration(): CampaignModuleEditConfiguration {
  return {
    renderCampaignEdit: () => null,
    renderCampaignPublish: () => null,
    getCampaign: async (apolloClient: any) => console.log('No get available for default campaign.'),
    duplicateCampaign: async (apolloClient: any, campaign: any, newCampaignId: string) =>
      console.log('No duplication available for default campaign.'),
    saveCampaign: async (apolloClient: any, campaign: any) =>
      console.log('No mutation available for default campaign.'),
    publishCampaign: async (apolloClient: any, publishInput: any) =>
      console.log('No publish available for default campaign.')
  };
}

function getPvsCampaignConfiguration(): CampaignModuleEditConfiguration {
  return {
    renderCampaignEdit: PvsCampaignEditConfiguration.renderCampaignEdit,
    renderCampaignPublish: PvsCampaignEditConfiguration.renderCampaignPublish,
    getCampaign: PvsCampaignEditConfiguration.getCampaign,
    duplicateCampaign: PvsCampaignEditConfiguration.duplicateCampaign,
    saveCampaign: PvsCampaignEditConfiguration.saveCampaign,
    publishCampaign: PvsCampaignEditConfiguration.publishCampaign
  };
}

function getP3CampaignConfiguration(): CampaignModuleEditConfiguration {
  return {
    renderCampaignEdit: P3CampaignEditConfiguration.renderCampaignEdit,
    renderCampaignPublish: P3CampaignEditConfiguration.renderCampaignPublish,
    getCampaign: P3CampaignEditConfiguration.getCampaign,
    duplicateCampaign: P3CampaignEditConfiguration.duplicateCampaign,
    saveCampaign: P3CampaignEditConfiguration.saveCampaign,
    publishCampaign: P3CampaignEditConfiguration.publishCampaign
  };
}

/**
 * Will return the CampaignModuleEditConfiguration for a given product id
 * @param productId A number that defines the campaign module product
 */
function getCampaignModuleConfiguration(productId: number): CampaignModuleEditConfiguration {
  switch (productId) {
    case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS:
      return getPvsCampaignConfiguration();
    case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS:
      return getP3CampaignConfiguration();
    default:
      return getDefaultCampaignConfiguration();
  }
}

export { getCampaignModuleConfiguration };
